import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyledLink } from './StyledComponents'

const TechnologyTab = (props) => {
  const { t } = useTranslation()

  return (
    <div className='container'>
      <div className='custom-tab'>
        <ul className='list-unstyled'>
          <StyledLink href="/technology">
            <li className={props.allTechnoActive ? "active" : ""}>
              {t('technology-tab.all-technologies')}
            </li>
          </StyledLink>
          <StyledLink href="/technology/overview">
            <li className={props.overViewActive ? "active" : ""}>{t('technology-tab.over-view')}</li>
          </StyledLink>
          <StyledLink href="/technology/deployment">
            <li className={props.deploymentOptionsActive ? "active" : ""}>{t('technology-tab.deployment-options')}</li>
          </StyledLink>
          <StyledLink href="/technology/integration">
            <li className={props.integrationOptionsActive ? "active" : ""}>{t('technology-tab.integration-options')}</li>
          </StyledLink>
          <StyledLink href="/technology/generating_pdf_reports_and_documents">
            <li className={props.pdfGenerationActive ? "active" : ""}>{t('technology-tab.pdf-generation')}</li>
          </StyledLink>
          <StyledLink href="/technology/security">
            <li className={props.securityActive ? "active" : ""}>{t('technology-tab.security-and-privacy')}</li>
          </StyledLink>
        </ul>
      </div>
    </div>
  )
}

export default TechnologyTab